import React, { Component } from 'react';
import SprintService from '../service/sprintService';
import SprintStatusService from "../service/sprintStatusService";
import TaskService from '../service/taskService';
import TaskStatusService from '../service/taskStatusService';
import TaskListWithCheckbox from '../components/tasklistWithCheckbox';
import NavigationBar from '../components/navigationBar';

export default class SprintDetailedSite extends Component {

    constructor(props) {
        super(props);
        this.sprintService = new SprintService();
        this.sprintStatusService = new SprintStatusService();
        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.state = {
            sprint: null,
            sprintStatuses: [],
            taskStatuses: [],
            selectedRemoveFromSprintTasks: [],
            selectedAddToSprintTasks: [],
            sprints: [],
            tasks: [],
            backlog: [],
            newSprintStatus: 0,
            selectedSprint: "",
            draggedTaskUuid: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckBoxRemoveFromSprint = this.handleCheckBoxRemoveFromSprint.bind(this);
        this.handleSelectedChangeRemoveFromSprint = this.handleSelectedChangeRemoveFromSprint.bind(this);
        this.handleCheckBoxAddToSprint = this.handleCheckBoxAddToSprint.bind(this);
        this.removeTasksToSelectedSprint = this.removeTasksToSelectedSprint.bind(this);
        this.transferTasksFromSprint = this.transferTasksFromSprint.bind(this);
    }

    handleChange(event) {
        this.setState({
            newSprintStatus: event.target.value
        });
    }

    handleSelectedChangeRemoveFromSprint(event) {
        this.setState({
            selectedSprint: event.target.value
        });
    }

    async getSprintStatuses() {
        let result = await this.sprintStatusService.getSprintkStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprintStatuses: result
            })
        }
    }

    async getSprint() {
        let result = await this.sprintService.getSprintInDetail(this.props.match.params.sprintUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprint: result
            })
        }
    }

    async transferTasksFromSprint(event) {
        event.preventDefault();
        if (this.state.selectedSprint === "") {
            return;
        }

        let result = await this.sprintService.transferTasksFromSprint(this.props.match.params.sprintUUID, this.state.selectedSprint);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("All open tasks have now been tranfered to the selected sprint");
            return;
        }
    }

    async getSprints() {
        let result = await this.sprintService.retrieveOpenSprints(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprints: result
            })
        }
    }

    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    handleCheckBoxAddToSprint(event, taskUUID) {
        let existsIndex = this.state.selectedAddToSprintTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedAddToSprintTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedAddToSprintTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedAddToSprintTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedAddToSprintTasks: array }))
            }
        }
    }

    handleCheckBoxRemoveFromSprint(event, taskUUID) {
        let existsIndex = this.state.selectedRemoveFromSprintTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedRemoveFromSprintTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedRemoveFromSprintTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedRemoveFromSprintTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedRemoveFromSprintTasks: array }))
            }
        }
    }

    async getTasksInSprint() {
        let result = await this.taskService.getTasksBySprint(this.props.match.params.sprintUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasks: result
            })
        }
    }

    async updateSprintStatus(event) {
        event.preventDefault();
        let result = await this.sprintService.updateSprintStatus(this.props.match.params.sprintUUID, this.state.newSprintStatus);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getSprint();
        }
    }

    async removeTasksToSelectedSprint(event) {
        event.preventDefault();
        let result = await this.sprintService.removeTasksFromSprint(this.props.match.params.sprintUUID, this.state.selectedRemoveFromSprintTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("Removed " + this.state.selectedRemoveFromSprintTasks.length + " tasks from the sprint");
            this.setState({
                selectedRemoveFromSprintTasks: []
            });
            this.getTasksInSprint();
            this.getBacklog();
        }
    }

    async addTasksToCurrentSprint(event) {
        event.preventDefault();
        let result = await this.sprintService.addTasksToSprint(this.props.match.params.sprintUUID, this.state.selectedAddToSprintTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("Added " + this.state.selectedAddToSprintTasks.length + " tasks to the sprint");
            this.setState({
                selectedAddToSprintTasks: []
            });
            this.getTasksInSprint();
            this.getBacklog();
        }
    }

    async getBacklog() {
        let result = await this.taskService.getTasksInBacklog(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                backlog: result
            })
        }
    }

    async dragoverHandler(event){
        event.preventDefault();
    }

    async dropHandler(event,taskStatusID){
        await this.taskService.changeTaskStatus(this.state.draggedTaskUuid,taskStatusID);

        this.setState({
                draggedTaskUuid: null
        });

        await this.getTasksInSprint();

    }

    async dragStartHandler(event,taskuuid){
        console.log(taskuuid);


        this.setState({
                draggedTaskUuid: taskuuid
            })
    }

    handleRedirectToTask(event, taskUUID) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.match.params.projectID + "/Task/" + taskUUID, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.match.params.projectID + "/Task/" + taskUUID);
        }
    }

    componentDidMount() {
        this.getSprint();
        this.getSprints();
        this.getSprintStatuses();
        this.getTaskStatuses();
        this.getTasksInSprint();
        this.getBacklog();
    }

    render() {
        const sprint = this.state.sprint;
        if (!sprint) return null;
        const sprintStatuses = this.state.sprintStatuses;
        if (sprintStatuses.length === 0) return null;
        const sprintStatus = sprintStatuses.find(element => element.statusID === sprint.currentStatus);
        const tasks = this.state.tasks;
        if (!tasks) return null;
        const backlog = this.state.backlog;
        if (!backlog) return null;
        const taskStatuses = this.state.taskStatuses;
        if (taskStatuses.length === 0) return null;
        const sprints = this.state.sprints;
        if (!sprints) return null;

        return (
            <div className="body">

                <NavigationBar {...this.props} />

                <main>

                    <p>{this.state.sprint.sprintUUID}</p>
                    <p>{this.state.sprint.sprintName}</p>
                    <p>{this.state.sprint.createdOn}</p>
                    <p>{this.state.sprint.lastUpdated}</p>
                    <p>{sprintStatus.statusName}</p>
                    <form action="#" onSubmit={(event) => { this.updateSprintStatus(event) }}>

                        <select name="taskStatus" id="newSprintStatus" onChange={this.handleChange} value={this.state.newSprintStatus}>
                            {sprintStatuses.map(sprintStatusesLoop => (
                                <option value={sprintStatusesLoop.statusID} key={sprintStatusesLoop.statusID}>{sprintStatusesLoop.statusName}</option>
                            ))}
                        </select>
                        <button type="submit">Update Sprint Status</button>
                    </form><br />
                    <form action="#" onSubmit={(event) => { this.transferTasksFromSprint(event) }}>

                        <select name="selectedSprint" id="selectedSprint" onChange={this.handleSelectedChangeRemoveFromSprint} value={this.state.selectedSprint}>
                            <option disabled={true} value={""}> -- select an option -- </option>
                            {sprints.map(sprintloop => (
                                (sprint.sprintUUID !== sprintloop.sprintUUID ? <option value={sprintloop.sprintUUID} key={sprintloop.sprintUUID}>{sprintloop.sprintName}</option> : "")
                            ))}
                        </select>
                        <button>Transfer all open tasks to sprint</button>
                    </form>

                    <p>Tasks in Sprint</p>

                    <div className='sprintOverview'>
                        {taskStatuses.map((taskStatus) => (
                            <div>
                                <div className='sprintTaskTitleCard' key={taskStatus.statusName}  >{taskStatus.statusName}</div>
                                    <div className='sprintTaskDiv'>
                                    {
                                    tasks.map((task) => (
                                        taskStatus.taskStatusID === task.taskStatus ? <div onClick={(event) => { this.handleRedirectToTask(event, task.taskUuid)}} className={task.taskUuid} draggable="true" onDragStart={(event) => this.dragStartHandler(event,task.taskUuid)}>{task.taskTitle} </div> : ""
                                    )) }
                                    <div className='moveSprintTaskBase' onDragOver={this.dragoverHandler} onDrop={(event) => this.dropHandler(event,taskStatus.taskStatusID)}>+</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <TaskListWithCheckbox tasks={this.state.tasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleCheckBoxRemoveFromSprint} />
                    {
                        sprintStatus.statusName !== "Finished" ?
                        <form action="#" onSubmit={(event) => { this.removeTasksToSelectedSprint(event) }}>
                            <button type="submit">Remove tasks from sprint</button>
                        </form>
                        : ""
                    }
                    

                    <p>Tasks in backlog</p>
                    <TaskListWithCheckbox tasks={this.state.backlog} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleCheckBoxAddToSprint} />
                    {
                        sprintStatus.statusName !== "Finished" ?
                        <form action="#" onSubmit={(event) => { this.addTasksToCurrentSprint(event) }}>
                            <button type="submit">Add tasks to sprint</button>
                        </form>
                        : ""
                    }
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/sprintDetailedSite.js